module.exports = __webpack_public_path__ + "static/dashboard-card-2-7fe418e2ae90dea70ac745a1f67341e9.png";